import TextArea from './TextArea.component';
import TextAreaTextMode from './displayMode/TextMode.component';

export { TextAreaTextMode };
export default TextArea;
